class ConnectedProducts extends HTMLElement {
  constructor() {
    super();
	this._placeholder = this.querySelector('.connected-products-placeholder__subtitle');
    this._originalSubtitleText = '';
    this._originalSubtitleColor = '';
    this._onEnter = this._onEnter.bind(this);
    this._onLeave = this._onLeave.bind(this);
  }

  connectedCallback() {
    if (this._placeholder) {
      this._originalSubtitleText = this._placeholder.textContent || '';
      const computed = window.getComputedStyle(this._placeholder);
      this._originalSubtitleColor = computed.color || '';
    }
    const items = this.querySelectorAll('.connected-product');
    if(!items) return;
    items.forEach((el) => {
      el.addEventListener('mouseenter', this._onEnter);
      el.addEventListener('mouseleave', this._onLeave);
    });
  }

  disconnectedCallback() {
    const items = this.querySelectorAll('.connected-product');
    if(!items) return;
    items.forEach((el) => {
      el.removeEventListener('mouseenter', this._onEnter);
      el.removeEventListener('mouseleave', this._onLeave);
    });
  }

  updateSubtitle( color) {
    if (!this._placeholder) return;
    this._placeholder.textContent = color;
  }

  _onEnter(e) {
    const el = e.currentTarget;
	const color = el?.getAttribute('data-product-color') || '';
    if (color) {
      this.updateSubtitle( color);
    } 
  }

  _onLeave() {
    this.updateSubtitle(this._originalSubtitleText);
  }
}

if (!customElements.get('connected-products')) {
  customElements.define('connected-products', ConnectedProducts);
}